import React from "react";

export const Field = ({ id, label, optional, error, children, hint }) => (
  <div>
    <label htmlFor={id} className="block text-sm font-semibold text-[#14201b]">
      {label}
      {optional && <span className="ml-1.5 text-xs font-normal text-[#6b7a73]">(pilihan)</span>}
    </label>
    {hint && <p className="mt-1 t-help">{hint}</p>}
    <div className="mt-1.5">{children}</div>
    {error && (
      <p className="mt-1.5 text-sm text-[#b4242b]" data-testid={`error-${id}`} role="alert">
        {error}
      </p>
    )}
  </div>
);

export const TextInput = ({ error, ...props }) => (
  <input
    {...props}
    className={`field-input ${error ? "border-[#d98a8e]" : "border-[#0f3f2f]/18"}`}
  />
);

export const SelectInput = ({ error, children, ...props }) => (
  <select
    {...props}
    className={`field-input ${error ? "border-[#d98a8e]" : "border-[#0f3f2f]/18"}`}
  >
    {children}
  </select>
);

export const Section = ({ letter, title, description, children, testId }) => (
  <section data-testid={testId} aria-labelledby={`${testId}-heading`}>
    <div className="flex items-start gap-3">
      <span className="grid place-items-center h-8 w-8 shrink-0 rounded-lg bg-gradient-to-b from-[#12876a] to-[#0f3f2f] text-sm font-bold text-white">
        {letter}
      </span>
      <div>
        <h2 id={`${testId}-heading`} className="t-h2 text-lg sm:text-xl">
          {title}
        </h2>
        {description && <p className="mt-1 t-help">{description}</p>}
      </div>
    </div>
    <div className="mt-5 pl-0 sm:pl-11 space-y-5">{children}</div>
    <div className="mt-8 h-px bg-gradient-to-r from-[#0f3f2f]/12 to-transparent" />
  </section>
);
